import PeopleList from "features/people/blocks/PeopleList";
import React from "react";

import PageLayout from "../../common/PageLayout";

const PeoplePage: React.FC = () => (
  <PageLayout>
    <PeopleList />
  </PageLayout>
);

export default PeoplePage;
